import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-geryRight",
  "use": "icon-geryRight-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" fill=\"none\" id=\"icon-geryRight\">\r\n  <path opacity=\"0.8\" d=\"M3.20312 7.82617L6.27771 10.9008L12.6417 4.5368\" stroke=\"#585A5C\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol